import type { BrandAlertsConfig } from './types';

/**
 * Builds the brand-alert client's config from the page.
 *
 * This is the only module that knows the client runs on a Django page:
 * the client itself takes a plain config object, which is what makes
 * it importable and unit-testable off the video-detail page.
 */

const pageContext = () => window.__VUMEDI_VIDEO_DETAIL_CONTEXT__ ?? {};

const required = (value: string | undefined, name: string): string => {
    if (!value) {
        throw new Error(`brand-alerts: missing ${name} in __VUMEDI_VIDEO_DETAIL_CONTEXT__`);
    }
    return value;
};

export const webBrandAlertsConfig = (): BrandAlertsConfig => {
    const context = pageContext();
    const forceCreativeId = new URLSearchParams(window.location.search).get('force_brand_alert_creative_id');

    return {
        creativeUrl: required(context.brandAlertCreativesUrl, 'brandAlertCreativesUrl'),
        trackingUrl: required(context.brandAlertTrackingUrl, 'brandAlertTrackingUrl'),
        viewedUuid: required(context.viewedUUID, 'viewedUUID'),
        csrftoken: context.csrftoken,
        ...(forceCreativeId ? { forceCreativeId } : {}),
    };
};

export const iosBrandAlertsConfig = (): BrandAlertsConfig => {
    const context = pageContext();

    return {
        creativeUrl: required(context.brandAlertCreativesUrl, 'brandAlertCreativesUrl'),
        trackingUrl: required(context.brandAlertTrackingUrl, 'brandAlertTrackingUrl'),
        viewedUuid: required(context.viewedUUID, 'viewedUUID'),
        accessToken: context.accessToken,
        ...(context.forceBrandAlertCreativeId ? { forceCreativeId: context.forceBrandAlertCreativeId } : {}),
    };
};
